module.exports = ".released-notes{max-height:70vh;overflow:auto}.version-text{margin-left:-16vh;font-size:x-small;vertical-align:bottom;color:darkgrey}\n"